// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

import resetRem from '@/common/scripts/resetRem.js';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import i18n from './i18n/i18n';
import 'font-awesome/css/font-awesome.css';
 import { Switch,Dropdown ,DropdownMenu,DropdownItem,Icon,Message,Notification} from 'element-ui';

Vue.config.productionTip = false;

Vue.use(resetRem);
Vue.use(VueAwesomeSwiper);
Vue.component(Switch.name, Switch);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(Icon.name, Icon);
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;


// 百度统计
router.afterEach((to, from, next) => {
  setTimeout(() => {
    (function () {
      // 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?e0cc108252c6634eeca0926d5b4e89ac';
      hm.id = 'baidu_tj';
      hm.language = 'JavaScript';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.appendChild(hm, s);
    })();
  }, 0);
});

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App),
  // 预渲染
  mounted () {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js